module.exports = __webpack_public_path__ + "images/ce4e0214f2e454d7e74bb62e607da42e.svg";